var React = require('react');

function Opportunities (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"10","y":"1","width":"9","height":"35","fill":"#FFBEED","key":0}),React.createElement("path",{"d":"M29 8.84483L19 1V36L29 8.84483Z","fill":"#B9599E","key":1}),React.createElement("path",{"d":"M0 26.9483L10 1V36L0 26.9483Z","fill":"#DD72BF","key":2})]);
}

Opportunities.defaultProps = {"width":"34","height":"37","viewBox":"0 0 34 37","fill":"none"};

module.exports = Opportunities;

Opportunities.default = Opportunities;
